let analyticsEnabled = true;

export function setAnalyticsEnabled(val: boolean) {
  analyticsEnabled = val;
}

export function getAnalyticsEnabled() {
  return analyticsEnabled;
}
